// Import react elements
import { useState } from 'react';



// Function to handle multiple api calls in a for loop whilst recording the progress, successful items, and failed items  
export const useBatchProcessor = () => {



    // Set state for loading
    const [isLoading, setIsLoading] = useState(false);

    // Set state for progress (X of Y)
    const [progress, setProgress] = useState({ current: 0, total: 0 });

    // Store successful items
    const [successfulItems, setSuccessfulItems] = useState([]);

    // Store failed items
    const [failedItems, setFailedItems] = useState([]);

    // DEBUG sleep - to slow down api calls
    //const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));



    // For loop function per item to run api call
    const processBatch = async (ids, actionConfig) => {

        //console.log("processBatch: ", ids, actionConfig);

        // Get the api call function and arguments
        const { apiFunction, getApiArgs } = actionConfig;

        // Set loading state
        setIsLoading(true);

        // Set progress state
        setProgress({ current: 0, total: ids.length });

        // Set successful items as empty array to start with
        setSuccessfulItems([]);

        // Set failed items as empty array to start with
        setFailedItems([]);

        // Set empty array
        const successes = [];

        // Set empty array
        const failures = [];

        // Loop through each item in the passed in ids array
        for (let i = 0; i < ids.length; i++) {

            // Set id to current id in the loop
            const id = ids[i];

            //console.log("action this id: ", id);

            try {

                // Get dynamic arguments for this ID
                const args = getApiArgs(id);

                //console.log("args: ", args);

                // Run the API function with those arguments
                const response = await apiFunction(...args);

                // Check if the API responded with an error
                if (response?.error_message) {

                    // It did so push the result to the failures array
                    failures.push({ id, errorMessage: response.error_message });

                    //console.log("failed id: ", id);

                } else {

                    // It was successful so push the id to the successes array
                    successes.push(id);

                    //console.log("successful id: ", id);

                }

            } catch (error) {

                // Handle thrown errors (like network errors)
                failures.push({ id, errorMessage: error.message || 'Unknown error' });

            }

            // Update the progress state (current = index plus 1) (total = length of ids array that we're looping through)
            setProgress({ current: i + 1, total: ids.length });

            // DEBUG - Wait 1 second before the next API call 
            //if (i < ids.length - 1) { // Optional: Skip delay after the last item

            //    await sleep(1000); // Delay of 1 second (1000ms)

            //}

        }

        // Update successful items to the successes array
        setSuccessfulItems(successes);

        // Update failed items to the failures array
        setFailedItems(failures);

        // Clear the loading state - it's finished
        setIsLoading(false);



        // Return the summary and action label for tailored messaging
        return {

            total: ids.length,
            successful: successes,
            failed: failures,
            actionLabel: actionConfig.label,
            allSuccessful: failures.length === 0,
            allFailed: successes.length === 0,
            partialSuccess: failures.length > 0 && successes.length > 0

        };

    };



    return {

        isLoading,
        progress,
        successfulItems,
        failedItems,
        processBatch

    };

};
